<template>
  <div class="flex gap-6 xl:gap-12">
    <button
      type="button"
     
      :class="computedClasses"
      @click="toggleLocale"
    >
      <TIcon :icon="['fal', 'globe']" /><span>{{ currentLocale?.name }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
const { toggleLocale, currentLocale } = useAppLocalization()

const computedClasses = computed(() => 'text-sm/6 flex items-center gap-2 font-semibold cursor-pointer hover:underline')
</script>
